export default __webpack_public_path__ + "static/media/Hotel.1784f6b9.graphql";